__turbopack_context__.v({
  "background": "AuthCard-module-scss-module__doLIxq__background",
  "banner": "AuthCard-module-scss-module__doLIxq__banner",
  "container": "AuthCard-module-scss-module__doLIxq__container",
  "content__footer": "AuthCard-module-scss-module__doLIxq__content__footer",
  "content__inner": "AuthCard-module-scss-module__doLIxq__content__inner",
  "content__logo": "AuthCard-module-scss-module__doLIxq__content__logo",
  "content__outer": "AuthCard-module-scss-module__doLIxq__content__outer",
  "content__title": "AuthCard-module-scss-module__doLIxq__content__title",
  "image": "AuthCard-module-scss-module__doLIxq__image",
  "quote": "AuthCard-module-scss-module__doLIxq__quote",
});
